fragment CompareTableFragment on compareTable_Entry {
  typeHandle
  heading

  showFilters

  # Feature Flags
  showVariants
  makeFirstProductSticky
  showProductLink
  showAddToCart
  showProductPrice

  # Old way
  collectionHandle: compareCollection

  # New way
  productComparison {
    ... on productComparison_Entry {
      compareFields {
        title
        slug
      }
      compareProducts {
        ... on shopifyProduct_Entry {
          title
          shopifyHandle
          compareProductAttributes {
            ... on compareProductAttribute_Entry {
              compareCategory {
                slug
              }
              body
            }
          }
        }
      }
    }
  }
}
